<div class="cu" #cuRoot>

<!-- ------------------Page Heading Start------------- -->
<!-- 
<div class="page_heading">
    <div class="container">
        <h2>Contact Us</h2>
    </div>
</div> -->

<!-- ------------------Page Heading End------------- -->
<section>
    <div class="contact-section cu-hero">
        <!-- ambient background: blobs, mesh, dots, rings, particles -->
        <div class="cu-hero__deco" aria-hidden="true">
            <span class="cu-blob cu-blob--1"></span>
            <span class="cu-blob cu-blob--2"></span>
            <span class="cu-blob cu-blob--3"></span>
            <span class="cu-mesh"></span>
            <span class="cu-dots cu-dots--1"></span>
            <span class="cu-dots cu-dots--2"></span>
            <span class="cu-ring cu-ring--1"></span>
            <span class="cu-ring cu-ring--2"></span>
            <span class="cu-particle" style="--x: 12%; --y: 26%; --pd: 0s"></span>
            <span class="cu-particle" style="--x: 30%; --y: 78%; --pd: 1.3s"></span>
            <span class="cu-particle" style="--x: 57%; --y: 14%; --pd: 2.4s"></span>
            <span class="cu-particle" style="--x: 84%; --y: 62%; --pd: 3.2s"></span>
            <span class="cu-particle" style="--x: 70%; --y: 90%; --pd: 4.1s"></span>
        </div>

        <div class="container rs-shell rs-shell--wide cu-hero__inner">
            <div class="cu-hero__grid">

                <!-- ============================================ left: copy -->
                <div class="cu-hero__lead">
                    <aside class="cu__intro">
                        <span class="cu-hero__badge rs-badge rs-badge--spark">
                            <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                                <path d="M12 2.5l1.9 5.6 5.6 1.9-5.6 1.9L12 17.5l-1.9-5.6L4.5 10l5.6-1.9L12 2.5z" />
                            </svg>
                            Get In Touch
                        </span>

                        <h2 class="faq-title cu-hero__title">
                            Have Any <span class="cu-grad">Questions?</span>
                        </h2>

                        <span class="cu-hero__rule" aria-hidden="true"></span>

                        <p class="rs-lede cu__lede cu-hero__lede">
                            Share a few details and the right specialist will get back to you —
                            usually within one business day.
                        </p>

                        <ul class="cu__perks" aria-label="What happens next">
                            <li class="cu-perk">
                                <span class="cu__perk-ico cu-perk__ico" aria-hidden="true">
                                    <svg viewBox="0 0 24 24" fill="none">
                                        <path d="M4 12.5l5 5L20 6.5" stroke="currentColor" stroke-width="2.4"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </span>
                                A reply from a real engineer, not a bot
                            </li>
                            <li class="cu-perk">
                                <span class="cu__perk-ico cu-perk__ico" aria-hidden="true">
                                    <svg viewBox="0 0 24 24" fill="none">
                                        <path d="M4 12.5l5 5L20 6.5" stroke="currentColor" stroke-width="2.4"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </span>
                                A clear scope, timeline and estimate
                            </li>
                            <li class="cu-perk">
                                <span class="cu__perk-ico cu-perk__ico" aria-hidden="true">
                                    <svg viewBox="0 0 24 24" fill="none">
                                        <path d="M4 12.5l5 5L20 6.5" stroke="currentColor" stroke-width="2.4"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </span>
                                Zero obligation, zero sales pressure
                            </li>
                        </ul>

                        <p class="cu__social-label cu-hero__social-label">Follow along</p>
                        <ul class="social-list list-lg list-primary-color list-flat clearfix cu__social cu-social">
                            <li class="cu-social__item" style="--d: 14"><a
                                    href="https://www.facebook.com/OfficialResiliencesoft/" target="_blank"
                                    aria-label="Facebook"><i class="fab fa-facebook"></i></a></li>
                            <li class="cu-social__item" style="--d: 11"><a href="https://twitter.com/ResilienceSoft1/"
                                    target="_blank" aria-label="Twitter"><i class="fab fa-twitter"></i></a></li>
                            <li class="cu-social__item" style="--d: 16"><a
                                    href="https://www.instagram.com/resiliencesoftofficial/" target="_blank"
                                    aria-label="Instagram"><i class="fab fa-instagram"></i></a></li>
                            <li class="cu-social__item" style="--d: 12"><a
                                    href="https://www.linkedin.com/in/hr-resiliencesoft-640933224" target="_blank"
                                    aria-label="LinkedIn"><i class="fab fa-linkedin"></i></a></li>
                        </ul>
                    </aside>

                    <!-- ================================= centre: illustration -->
                    <div class="cu-art" aria-hidden="true">
                        <span class="cu-art__glow"></span>
                        <span class="cu-art__orbit"></span>

                        <!-- phone mockup with a mini support dashboard -->
                        <div class="cu-art__phone" style="--d: 12">
                            <span class="cu-art__notch"></span>
                            <div class="cu-art__screen">
                                <span class="cu-art__avatar"></span>
                                <span class="cu-art__line cu-art__line--w70"></span>
                                <span class="cu-art__line cu-art__line--w45"></span>
                                <div class="cu-art__chart">
                                    <span style="--h: 44%"></span>
                                    <span style="--h: 72%"></span>
                                    <span style="--h: 56%"></span>
                                    <span style="--h: 90%"></span>
                                </div>
                                <span class="cu-art__line cu-art__line--w60"></span>
                            </div>
                        </div>

                        <!-- 3D-ish envelope -->
                        <div class="cu-art__envelope" style="--d: 18">
                            <span class="cu-art__env-back"></span>
                            <span class="cu-art__env-letter">
                                <svg viewBox="0 0 24 24" fill="none">
                                    <path d="M4 8h16v10H4zM4 8l8 6 8-6" stroke="currentColor" stroke-width="1.8"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </span>
                            <span class="cu-art__env-flap"></span>
                        </div>

                        <!-- chat bubbles -->
                        <span class="cu-art__bubble cu-art__bubble--1" style="--d: 15">
                            <i></i><i></i><i></i>
                        </span>
                        <span class="cu-art__bubble cu-art__bubble--2" style="--d: 10">
                            <b></b><b></b>
                        </span>

                        <!-- floating notification / message cards -->
                        <span class="cu-art__note cu-art__note--msg" style="--d: 20">
                            <svg viewBox="0 0 24 24" fill="none">
                                <path d="M4 5.5h16v10H8l-4 3.5V5.5z" stroke="currentColor" stroke-width="1.8"
                                    stroke-linejoin="round" />
                            </svg>
                            New message
                        </span>
                        <span class="cu-art__note cu-art__note--ai" style="--d: 16">
                            <svg viewBox="0 0 24 24" fill="none">
                                <path d="M12 3l1.7 5L19 9.7l-5.3 1.6L12 16.5l-1.7-5.2L5 9.7l5.3-1.7L12 3z"
                                    stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" />
                            </svg>
                            AI assistant
                        </span>
                        <span class="cu-art__note cu-art__note--ok" style="--d: 13">
                            <svg viewBox="0 0 24 24" fill="none">
                                <path d="M4 12.5l5 5L20 6.5" stroke="currentColor" stroke-width="2.6"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            Replied
                        </span>
                    </div>
                </div>

                <!-- ============================================ right: form -->
                <div class="cu__panel-wrap cu-panel-wrap">
                    <div class="contact-form cu__panel cu-panel">
                        <span class="cu__panel-shine" aria-hidden="true"></span>

                        <header class="cu-panel__head">
                            <span class="cu-panel__ico" aria-hidden="true">
                                <svg viewBox="0 0 24 24" fill="none">
                                    <path d="M4 7.5h16v11H4zM4 7.5l8 6 8-6" stroke="currentColor" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </span>
                            <h3 class="cu__panel-title">Send us a message</h3>
                        </header>

                        <form [formGroup]="formData" (ngSubmit)="submit(phone)">
                            <div class="cu__fields">
                                <div class="form-group cu__field cu-field cu__field--half">
                                    <input name="ctl00$ContentPlaceHolder1$txtenqnam" type="text"
                                        id="ctl00_ContentPlaceHolder1_txtenqnam" placeholder=" "
                                        aria-label="Full name" class="form-control rs-input" required
                                        formControlName="Name" (keypress)="noSpace($event)">
                                    <label for="ctl00_ContentPlaceHolder1_txtenqnam">Full Name*</label>
                                    @if(fullName && fullName.invalid && fullName.touched){
                                    <div id="formError" class="rs-error">
                                        <span *ngIf="fullName.errors?.['required']">
                                            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Required
                                        </span>
                                        <span *ngIf="fullName.errors?.['pattern'] && !fullName.errors?.['required']">
                                            Invalid Name input </span>
                                    </div>
                                    }
                                </div>

                                <div class="form-group cu__field cu-field cu__field--half">
                                    <input name="ctl00$ContentPlaceHolder1$txtenqeml" type="email"
                                        id="ctl00_ContentPlaceHolder1_txtenqeml" placeholder=" "
                                        aria-label="Email address" class="form-control rs-input" required
                                        formControlName="Email">
                                    <label for="ctl00_ContentPlaceHolder1_txtenqeml">Email*</label>
                                    @if(email && email.invalid && email.touched){
                                    <div id="formError" class="rs-error">
                                        <span *ngIf="email.errors?.['required']">
                                            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Required
                                        </span>
                                        <span *ngIf="email.errors?.['pattern'] && !email.errors?.['required']">
                                            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Invalid email
                                        </span>
                                    </div>
                                    }
                                </div>

                                <div class="form-group position-relative cu__field cu-field cu__field--full cu__field--tel">
                                    <span class="cu-field__legend">Phone number</span>
                                    <ngx-material-intl-tel-input
                                        fieldControlName="Number"
                                        [preferredCountries]="['in', 'us']"
                                        [enablePlaceholder]="true"
                                        [enableSearch]="true"
                                        [format]="'national'"
                                        [separateDialCode]="true"
                                        #phone
                                    >
                                    </ngx-material-intl-tel-input>
                                    <div id="formError" class="rs-error"
                                        *ngIf="contact && contact.invalid && contact.touched">
                                        <span *ngIf="contact.errors?.['required']">
                                            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Required
                                        </span>
                                        <span
                                            *ngIf="contact.errors?.['validatePhoneNumber'] && !contact.errors?.['required']">
                                            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Invalid input
                                        </span>
                                    </div>
                                </div>

                                <div class="form-group cu__field cu-field cu__field--full">
                                    <textarea name="ctl00$ContentPlaceHolder1$txtmsg" rows="4" cols="20"
                                        id="ctl00_ContentPlaceHolder1_txtmsg" class="form-text rs-textarea"
                                        placeholder=" " aria-label="Message" formControlName="msg"
                                        (keypress)="noSpace($event)"></textarea>
                                    <label for="ctl00_ContentPlaceHolder1_txtmsg">Message*</label>
                                    <div id="formError" class="rs-error" *ngIf="msg && msg.invalid && msg.touched">
                                        <span *ngIf="msg.errors?.['required']">
                                            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Required
                                        </span>
                                        <span *ngIf="msg.errors?.['minlength'] && !msg.errors?.['pattern']">
                                            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Minimum 10
                                            Words are Required </span>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group cu__actions cu-panel__foot">
                                <button class="form_button_send rs-btn rs-btn--primary cu-send" rsRipple type="submit">
                                    <span>Send Message</span>
                                    <span class="rs-btn__icon" aria-hidden="true">
                                        <svg viewBox="0 0 24 24" fill="none">
                                            <path d="M5 12h13M13 6l6 6-6 6" stroke="currentColor" stroke-width="2.2"
                                                stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </span>
                                </button>
                                <p class="cu__assure">
                                    <i class="fa fa-lock" aria-hidden="true"></i>
                                    We never share your details.
                                </p>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- ------------------------------------------------ contact cards -->
<section class="cu-cards-section">
    <div class="container rs-shell">
        <div class="mrb-40 cu__cards cu-cards">
            <div class="contact-block rs-card rs-card--wash">
                <span class="cu-card__line" aria-hidden="true"></span>
                <div class="contact-icon-container rs-ico" aria-hidden="true">
                    <a>
                        <img loading="lazy" class="contact-icon" src="/assets/images/office-icon.png"
                            alt="office-icon">
                    </a>
                </div>

                <div class="contact-details mrl-30">
                    <h5 class="icon-box-title mrb-10 rs-card__title">Our Address</h5>
                    <p class="mrb-0"><a>2nd Floor Emerald Plaza, Opposite Vinayak Netralaya,
                            Near Agrasen Chowk,
                            Link Road Bilaspur C.G.</a> </p>
                </div>
            </div>

            <div class="contact-block rs-card rs-card--wash">
                <span class="cu-card__line" aria-hidden="true"></span>
                <div class="contact-icon-container rs-ico">
                    <a href="tel:07752-414580" aria-label="Call our office">
                        <img loading="lazy" class="contact-icon" src="/assets/images/telephone1.png"
                            alt="telephone">
                    </a>
                </div>

                <div class="contact-details mrl-30">
                    <h5 class="icon-box-title mrb-10 rs-card__title">Phone Number</h5>
                    <p class="mrb-0"><a class="contact-number-office" href="tel:9109911372">9109911372</a>
                        &nbsp;, <a class="contact-number-office" href="tel:9201996377">9201996377</a>
                    </p>
                </div>
            </div>

            <div class="contact-block rs-card rs-card--wash">
                <span class="cu-card__line" aria-hidden="true"></span>
                <div class="contact-icon-container rs-ico">
                    <a href="mailto:info@resiliencesoft.com" aria-label="Email us">
                        <img loading="lazy" class="contact-icon" src="/assets/images/mail1.png" alt="mail">
                    </a>
                </div>

                <div class="contact-details mrl-30">
                    <h5 class="icon-box-title mrb-10 rs-card__title">Email Us</h5>
                    <p class="mrb-0"><a class="contact-number-office" href="mailto:info@resiliencesoft.com">
                            info&#64;resiliencesoft.com </a>
                        <br>
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- <section>
  <div #view class="elfsight-app-4992bdf1-a43a-49b3-8e6d-47edd405d5df" ></div>
</section> -->

<section class="cu__map-section cu-map">
    <div class="rs-shell">
        <div class="cu-map__shell">
            <span class="cu-map__glow" aria-hidden="true"></span>

            <div class="cu-map__bar">
                <span class="cu-map__badge">
                    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                        <path d="M12 21s7-5.4 7-10.4A7 7 0 005 10.6C5 15.6 12 21 12 21z" stroke="currentColor"
                            stroke-width="1.8" stroke-linejoin="round" />
                        <circle cx="12" cy="10.4" r="2.4" stroke="currentColor" stroke-width="1.8" />
                    </svg>
                    Locate Us
                </span>
                <p class="cu-map__meta">
                    2nd Floor Emerald Plaza, Link Road, Bilaspur (C.G.)
                    <span>Mon – Sat · 10:00 – 19:00 IST</span>
                </p>
            </div>

            <div id="maplocation" class="map_holder cu__map cu-map__frame">
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3697.2949616509404!2d82.15240278966186!3d22.07654963837098!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a280b3994383cad%3A0x96b4892d81b97229!2sResiliencesoft!5e0!3m2!1sen!2sin!4v1663847088436!5m2!1sen!2sin"
                    title="Resiliencesoft office location on Google Maps"
                    width="100%" height="350" style="border:0;" allowfullscreen="" loading="lazy"></iframe>

                <span class="cu-map__pin" aria-hidden="true">
                    <span class="cu-map__pin-pulse"></span>
                    <svg viewBox="0 0 24 24" fill="none">
                        <path d="M12 21s7-5.4 7-10.4A7 7 0 005 10.6C5 15.6 12 21 12 21z" fill="currentColor" />
                        <circle cx="12" cy="10.3" r="2.5" fill="#fff" />
                    </svg>
                </span>
            </div>
        </div>
    </div>
</section>

<!-- ------------------------------------------------------------- CTA -->
<section class="cu-cta" aria-labelledby="cu-cta-title">
    <div class="rs-shell">
        <div class="cu-cta__panel">
            <span class="cu-cta__overlay" aria-hidden="true"></span>
            <span class="cu-cta__blob cu-cta__blob--1" aria-hidden="true"></span>
            <span class="cu-cta__blob cu-cta__blob--2" aria-hidden="true"></span>
            <span class="cu-particle cu-particle--onDark" style="--x: 10%; --y: 24%; --pd: 0s" aria-hidden="true"></span>
            <span class="cu-particle cu-particle--onDark" style="--x: 28%; --y: 76%; --pd: 1.5s" aria-hidden="true"></span>
            <span class="cu-particle cu-particle--onDark" style="--x: 74%; --y: 20%; --pd: 2.6s" aria-hidden="true"></span>
            <span class="cu-particle cu-particle--onDark" style="--x: 90%; --y: 68%; --pd: 3.4s" aria-hidden="true"></span>

            <div class="cu-cta__inner">
                <span class="rs-badge rs-badge--spark cu-cta__badge">
                    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                        <path d="M12 2.5l1.9 5.6 5.6 1.9-5.6 1.9L12 17.5l-1.9-5.6L4.5 10l5.6-1.9L12 2.5z" />
                    </svg>
                    Prefer to talk it through?
                </span>

                <h2 class="cu-cta__title" id="cu-cta-title">
                    Let's turn your idea into a <span class="cu-grad">plan</span>
                </h2>

                <p class="cu-cta__text">
                    Book a callback and a specialist will walk you through scope, timeline and cost —
                    or take a look at what we have already shipped.
                </p>

                <div class="cu-cta__actions">
                    <a routerLink="/call-back" class="rs-btn rs-btn--primary cu-magnet" rsRipple>
                        <span>Request Callback</span>
                        <span class="rs-btn__icon" aria-hidden="true">
                            <svg viewBox="0 0 24 24" fill="none">
                                <path d="M5 12h13M13 6l6 6-6 6" stroke="currentColor" stroke-width="2.2"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </span>
                    </a>
                    <a routerLink="/our-portfolio" class="rs-btn rs-btn--ghost cu-magnet">
                        <span>View Portfolio</span>
                        <span class="rs-btn__icon" aria-hidden="true">
                            <svg viewBox="0 0 24 24" fill="none">
                                <path d="M5 12h13M13 6l6 6-6 6" stroke="currentColor" stroke-width="2.2"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</section>
</div>
